import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './pages/login/login.component';
import { NopagefoundComponent } from './shared/nopagefound/nopagefound.component';
import { TermsComponent } from './pages/terms/terms.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LoginGuardGuard } from './services/guards/login-guard.guard';


const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'terms', component: TermsComponent },
  { 
    path: 'dashboard', 
    component: DashboardComponent, 
    canActivate: [ LoginGuardGuard ],
    children: [
      { 
        path: '', 
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      { 
        path: 'game-history', 
        loadChildren: () => import('./modules/game-history/game-history.module').then(m => m.GameHistoryModule)
      },
      
      { 
        path: 'game-fourpicsoneword', 
        loadChildren: () => import('./modules/game-fourpicsoneword/game-fourpicsoneword.module').then(m => m.GameFourpicsonewordModule)
      }
      ,
      
      { 
        path: 'game-trivial', 
        loadChildren: () => import('./modules/game-trivial/game-trivial.module').then(m => m.GameTrivialModule)
      }
    ] 
  },
  { path: '**', component: NopagefoundComponent }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
